module.exports = __webpack_public_path__ + "static/img/layout.f006729.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/quizzes/java/images/layout.png
// module id = +63h
// module chunks = 1